import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-layout',
  templateUrl: './load-layout.component.html',
  styleUrls: ['./load-layout.component.scss']
})
export class LoadLayoutComponent implements OnInit {

  @Input() public isDashboard: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
